var exports = {
  "kL": "xa15a2ab7--409f07--container",
  "ad": "xa15a2ab7--409f07--container--hide",
  "Qs": "xa15a2ab7--409f07--content",
  "DD": "xa15a2ab7--409f07--title",
  "h_": "xa15a2ab7--409f07--description",
  "aA": "xa15a2ab7--409f07--fix_wrapper",
  "bL": "xa15a2ab7--409f07--link_fix",
  "_o": "xa15a2ab7--409f07--user_confirmed_fix",
};

module.exports = exports;
